export async function fetchReplies(id) {
  try {
    let response = await fetch(`/api/posts/${id}/replies`);
    let replies = await response.json();
    if (response.ok) {
      return replies;
    }
    if (replies.satusCode === 401 || replies.satusCode === 403) {
      console.error('Replies not found');
    }
  } catch (err) {
    console.error(err);
  }
}

/**
 * Get user unread posts
 * @param {Object} params - Request parameters
 * @param {string} params.authorUserId - User ID
 * @param {number} [params.offset=0] - Pagination offset
 * @param {number} [params.limit=15] - Number of posts per page
 * @returns {Promise<Object>} - Response object with results
 */
export async function fetchUserUnreadPosts(params) {
  try {
    const query = {
      authorUserId: params.authorUserId,
      limit: params.limit || 15,
    };
    if (params.after) query.after = params.after;

    const queryParams = new URLSearchParams(query).toString();

    const response = await fetch(`/api/posts/unread?${queryParams}`, {
      headers: {
        'Cache-Control': 'no-cache',
      },
    });

    if (!response.ok) {
      console.error('Error fetching unread posts:', response.statusText);
      return { results: [] };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return { results: [] };
  }
}

/**
 * Mark posts as read by user (bulk or paginated)
 * @param {Object} params - Request parameters
 * @param {string} params.authorUserId - User ID (required)
 * @param {number} [params.limit] - Optional limit
 * @param {string} [params.after] - Optional pagination cursor
 * @param {boolean} [params.reversed] - Optional reversed flag
 * @returns {Promise<Response>} - API response
 */
export async function markPostsAsRead({ authorUserId, limit, after, reversed }) {
  try {
    const body = { authorUserId };
    if (limit !== undefined) body.limit = limit;
    if (after !== undefined) body.after = after;
    if (reversed !== undefined) body.reversed = reversed;

    const response = await fetch('/api/posts/mark-as-read', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (response.status === 204) {
      return true;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error marking posts as read:', error);
    return null;
  }
}

/**
 * Mark a single post as read for the current user
 * @param {string} postId - ID of the post to mark as read
 * @returns {Promise<Response>} - API response
 */
export async function markSinglePostAsRead(postId) {
  try {
    const response = await fetch(`/api/posts/${postId}/mark-as-read`, {
      method: 'POST',
    });
    return response;
  } catch (error) {
    console.error('Error marking single post as read:', error);
    return null;
  }
}
